// extracted by mini-css-extract-plugin
module.exports = {"wrap":"e_cM","check":"e_dM","svg":"e_eM","check_sm":"e_fM","check_md":"e_gM","mark":"e_hM","tip":"e_iM","tip_above":"e_jM","tipTitle":"e_kM","tip_below":"e_lM"};